import PropTypes from '../_util/vue-types';
import { booleanType, eventType, stringType } from '../_util/type';
export function convertLegacyProps(type) {
    if (type === 'danger') {
        return { danger: true };
    }
    return { type };
}
export const buttonProps = () => ({
    prefixCls: String,
    type: String,
    htmlType: { type: String, default: 'button' },
    shape: { type: String },
    size: {
        type: String,
    },
    loading: {
        type: [Boolean, Object],
        default: () => false,
    },
    disabled: { type: Boolean, default: undefined },
    ghost: { type: Boolean, default: undefined },
    block: { type: Boolean, default: undefined },
    danger: { type: Boolean, default: undefined },
    icon: PropTypes.any,
    href: String,
    target: String,
    title: String,
    /** We default to providing a space between two Chinese characters; set to false to disable */
    autoInsertSpace: booleanType(),
    /** Set the icon position of button */
    iconPlacement: stringType(),
    /** @deprecated Please use `iconPlacement` instead */
    iconPosition: stringType(),
    /** Set button color (use with `variant`) */
    color: stringType(),
    /** Set button variant (use with `color`) */
    variant: stringType(),
    onClick: eventType(),
    onMousedown: eventType(),
});
export default buttonProps;
